
import DropDown from "../../UI/Inputs/DropDown";
import TextField from "../../UI/Inputs/TextField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";

const AdvanceQuestionProps = ({ data, setter,visibility=true}) => {

  if(data.type !== "Calculate"){return;}
  return (

    <>
      { (<div className="border-gray-300 border-2 p-4 rounded-md">
      <p className="text-lg mb-4">Advanced Properties</p>
      {data.type === "Calculate" ? (
        <TextField
          icon={ <FontAwesomeIcon icon={faCalculator} />}
          name="formula"
          value={data.formula}
          label={"Enter formula for calculation"}
          onValueChange={(name, value) => setter({ ...data, [name]: value })}
        />
      ) : (
        <></>
      )}
     {visibility && <div className="grid grid-cols-10 space-x-4">
        <div className="col-span-2 ">
          <DropDown
            options={[
              { name: "Yes", value: "yes" },
              { name: "No", value: "no" },
            ]}
            label="Select Skip"
            value={data.skip || "no"}
            onValueChange={(value) => {
              if (value) {
                setter({ ...data, skip: value });
              }
            }}
          />
        </div>
        <div className="col-span-8">
          <TextField
            disabled={data.skip === "no" ? true : false}
            name="skipLogic"
            value={data.skip === "no" ? "" : data.skipLogic || ""}
            label={"Enter Skip Logic Here"}
            onValueChange={(name, value) => setter({ ...data, [name]: value })}
          />
        </div>
      </div>}
    </div>)}
    </>
  );
};

export default AdvanceQuestionProps;
